import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const isDev = process.env.NODE_ENV === 'development';

root.render(
  isDev ? <App /> : <React.StrictMode><App /></React.StrictMode>
);

// Registra el Service Worker para modo PWA
serviceWorkerRegistration.register();

reportWebVitals();
